import Card from "@Modules/eventPage/components/PaymentPlan/components/Card/Card";
import RadioInput from "@Modules/eventPage/components/PaymentPlan/components/RadioInput/RadioInput";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import React, { FC } from "react";
import { CREDS_ALREADY_EXISTS_CHOICES } from "../../FormData";
import { IConfirmCredsChange } from "./ConfirmCredsChange.interfaces";
import styles from "./ConfirmCredsChange.module.scss";

const ConfirmCredsChange: FC<IConfirmCredsChange.IProps> = ({
    value,
    availabilityApiResponseData,
    onChange,
}) => {
    const {
        customer_mismatch_data: customerMismatchData,
        disable_customer_updation: disableCustomerUpdation,
    } = availabilityApiResponseData ?? {};
    const {
        existing_email: existingEmail,
        existing_phone_number: existingPhone,
        new_phone_number: newPhoneNumber,
        new_email: newEmail,
        new_country_code: newCountryCode,
    } = customerMismatchData ?? {};
    const newCompletePhone = existingPhone
        ? `${newCountryCode}${newPhoneNumber}`
        : undefined;
    const Icon = existingEmail ? EmailOutlinedIcon : LocalPhoneRoundedIcon;

    const options = [
        {
            label: "Proceed with existing account details",
            value: CREDS_ALREADY_EXISTS_CHOICES.PROCEED_WITH_ALREADY_EXISTING_DETAILS,
            info: (
                <div className={styles.info}>
                    <Icon /> {existingEmail ?? existingPhone}
                </div>
            ),
        },
        {
            label: "Proceed to update account details",
            value: CREDS_ALREADY_EXISTS_CHOICES.PROCEED_TO_UPDATE_ACCOUNT_DETAILS,
            info: (
                <div className={styles.info}>
                    <Icon /> {newEmail ?? newCompletePhone}
                </div>
            ),
            disabled: disableCustomerUpdation,
        },
    ];

    return (
        <div className={styles.root}>
            <p className={styles.info}>
                {disableCustomerUpdation ? (
                    "A user account already exists with the Mobile number provided"
                ) : (
                    <>
                        {existingEmail
                            ? "Phone number is already present with another Email."
                            : null}
                        {existingPhone
                            ? "Email already present with another phone number."
                            : null}
                        Please proceed by selecting one of the given options:
                    </>
                )}
            </p>

            {options.map(({ label, value: optionValue, info, disabled }) => (
                <Card
                    active={value === optionValue}
                    onClick={() => onChange?.(optionValue)}
                    key={label}
                    disabled={disabled}
                >
                    <RadioInput
                        label={label}
                        info={info}
                        radioProps={{
                            checked: value === optionValue,
                        }}
                    />
                </Card>
            ))}
        </div>
    );
};

export default ConfirmCredsChange;
